export default {
    name : 'modalBox',

    init()
    {
        this.run();
    },
    run ()
    {
        const fields = document.querySelectorAll('.modal-c2a');

        fields.forEach((field) => {
            field.addEventListener('click', this.toggleModalBox);
            }
        );
    },

    toggleModalBox(event)
    {
        _log(this);
        _log(event);
        const modalId = this.dataset.rel;

        document.getElementById(modalId).classList.toggle('active');
    },

}